module.exports = __webpack_public_path__ + "icon1.png?42ab79f3694f86e9095c2ad43aa7322f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon1.png
// module id = 358
// module chunks = 0